



































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PurchaseOrderItemView extends Vue {
  public createPurchaseDelivery = Components.CreatePurchaseDelivery;
  public items: Common.PurchaseOrderItem[] = new Array(0);
  public params: Common.OrderItemQuery = new Common.OrderItemQuery(Common.SalesPurchaseFlags.Purchase);
  public importQuery = new Common.OrderItemImportQuery('発注明細',Common.SalesPurchaseFlags.Purchase);
  public exportQuery = new Common.OrderItemExportQuery('発注明細', this.params,Common.SalesPurchaseFlags.Purchase);
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'orderItemNo', text: '明細番号' },
    { value: 'orderDate', text: '発注日' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'commodity', text: '商品' },
    { value: 'answerDeliveryDate', text: '回答納期' },
    { value: 'scheduledDeliveryDate', text: '入荷予定日' },
    { value: 'orderNo', text: '発注番号' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'salesOrderItemNo', text: '受注明細番号' },
    { value: 'commodityName', text: '商品名称' },
    { value: 'refNo', text: '発注管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;
  public visibleTypes = Common.visibleTypes;
    
  @Prop() public orderNo:string;
  @Prop() public orderItemNo:string;
  @Prop() public salesOrderItemNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;  
  @Prop() public state:Common.OrderItemStatus;    
  @Prop() public scheduledDeliveryDateTo: Date;
  @Prop({default:null}) public popup: Components.PopupEditor; 
  
  public hasLicenseCurrency: boolean = false;
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    

    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ

    //'状態', '発注番号', '行番号', '明細番号', '受注明細番号', '発注日', '部門', '仕入先', '担当者', '商品',
    // '商品名称', '棚卸対象外', '単位', 'SKU', '発注数量', '単価', '税区分', 'NCV', '取引金額',  '備考',
    // '回答納期', '入荷予定日', '発注残数量','発注残数量(計上単位)', 'クローズ数量', '発注管理番号', '受注管理番号', '顧客注文番号', 'ワークフロー', '初回保存日',
    // '初回保存者', '最終更新日', '最終更新者'
    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 170),
      new Common.GridItemConfiguration('明細番号', 150),
      new Common.GridItemConfiguration('発注日', 120),
      new Common.GridItemConfiguration('仕入先', 180),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),              
      new Common.GridItemConfiguration('単位', 100),
      new Common.GridItemConfiguration('発注数量', 120),
      new Common.GridItemConfiguration('回答納期', 120),
      new Common.GridItemConfiguration('入荷予定日', 120),              
      new Common.GridItemConfiguration('発注番号', 120),
      new Common.GridItemConfiguration('取引通貨', 120,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('単価', 120),
      new Common.GridItemConfiguration('税区分', 120),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),                              
      new Common.GridItemConfiguration('受注明細番号', 150),

      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('棚卸対象外', 150),
      new Common.GridItemConfiguration('NCV', 150,this.hasLicenseCurrency),            
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('入荷済み数量', 150),
      new Common.GridItemConfiguration('クローズ数量', 150),      
      new Common.GridItemConfiguration('発注残数量', 150),
      new Common.GridItemConfiguration('発注残数量(計上単位)', 150),
      new Common.GridItemConfiguration('発注管理番号', 150),
      // new Common.GridItemConfiguration('受注管理番号', 150),
      // new Common.GridItemConfiguration('顧客注文番号', 150),            

      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),          
    );
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,true,false));
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.orderNo){
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }
    else if(this.salesOrderItemNo){
      this.params.salesOrderItemNo = this.salesOrderItemNo;
      this.params.state = null;
    }
    else if(this.orderItemNo){
      this.params.orderItemNo = this.orderItemNo;
      this.params.state = null;
    }else if (!this.commodity && !this.sku && !this.state && !this.scheduledDeliveryDateTo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}    
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.state)this.params.state = this.state;   
    if (this.scheduledDeliveryDateTo)this.params.scheduledDeliveryDateTo = this.scheduledDeliveryDateTo;        
    
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_purchaseDelivery');
    this.$api.formatter.ensureListLoaded('workflow_purchaseInvoice');
  }
 
  public async onCreate(obj: Common.PurchaseOrderItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_purchaseOrderItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 商品変更時に商品名・予備項目を設定する
  public onChangeCommodity(item:Common.PurchaseOrderItem){
    item.onChangeCommodity(this.tenantSettings);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.PurchaseOrderItem){
    this.$api.execute(new Common.OrderGetItemPriceQuery(item.order, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  // 状態から編集可能か判別する
  public isEditable(state: Common.OrderItemStatus):boolean{
    if(state == Common.OrderItemStatus.PurchaseOrderSaving) return true;
    return false;
  }

  // 保存状態、且つ受注非継承時に編集可
  public isEditableNoTakeOverSales(state: Common.OrderItemStatus, item: Common.OrderItem):boolean{
    if(!this.isEditable(state)) return false;
    if(item.salesOrderItemNo) return false;
    return true;
  }

  // 一覧でチェックされている発注明細
  public checkedOrderItems: Array<Common.OrderItem>= new Array(0);
  public getCheckedOrderItems(){
    this.checkedOrderItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.deliveringQuantity = 0;
        this.checkedOrderItems.push(obj);
      }
    });
  }

  // 納期更新用プロパティ
  public uddAnswerDeliveryDate:Date = new Date().getCalendarDate();
  public uddScheduledDeliveryDate:Date = new Date().getCalendarDate();

  // 納期更新ダイアログの表示
  public showUpdateDeliveryDateDialog() {
    this.getCheckedOrderItems();

    // ダイアログ表示前バリデーション
    if(this.checkedOrderItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }

    // プロパティの初期化
    this.uddAnswerDeliveryDate = null;//new Date().getCalendarDate();
    this.uddScheduledDeliveryDate = null;//new Date().getCalendarDate();

    // ダイアログを表示
    (this.$refs.updateDeliveryDateDialog as Components.ListDialog).showDialog();
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 納期更新の実行
  public async submitUpdateDeliveryDate() {
    var query = new Common.UpdateDeliveryDateQuery();
    query.orderItems = this.checkedOrderItems;
    query.answerDeliveryDate = this.uddAnswerDeliveryDate;
    query.scheduledDeliveryDate = this.uddScheduledDeliveryDate;
    await this.$api.execute(query).then(res => {
      this.refreshListView();
    });
  }
  // 入荷処理ダイアログの表示
  public showCreatePurchaseDeliveryDialog(isTransitPost :boolean) {
    this.getCheckedOrderItems();
    let componentClass = Vue.extend(this.createPurchaseDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: this.checkedOrderItems,
          parentMainList: this.$refs.mainList,
          parent: this,
          isTransitPost: isTransitPost,
          isItemFlag: true,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }
  
  // 受注明細一覧へ遷移する
  public showSalesOrderItem(itemNo: string){
    if(itemNo) this.$router.push(String.format('/sales/SalesOrderItem?orderItemNo={0}',itemNo));
  }

  // 発注一覧へ遷移する
  public showPurchaseOrder() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrderItem;
    this.$router.push(String.format('/purchase/PurchaseOrder?orderNo={0}',obj.order.orderNo));
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.PurchaseOrderItem){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseOrder, sourceNo : item.orderNo, isItem: true},this.$el);
  }
  // 入荷明細表示ボタンの非活性制御
  public disabledShowPurchaseDeliveryItemButton(item: Common.OrderItem):boolean{
    return item.state != Common.OrderItemStatus.PurchaseOrderDelivering && item.state != Common.OrderItemStatus.PurchaseOrderCompleted;
  }

  // 入荷明細一覧へ遷移する
  public showPurchaseDeliveryItem(){
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrderItem;
    if(obj) {
      let routeData = this.$router.resolve(String.format('/purchase/PurchaseDeliveryItem?orderItemNo={0}', obj.orderItemNo));
      window.open(routeData.href, '_blank');
    }
  }

  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.OrderMemo || usedType == Common.UsedTypes.CommodityMemo ;
  }    
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }  
}
